(function () {
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
    try {
      return new Intl.NumberFormat("fr-FR", { style: "currency", currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace(".", ",") + " €";
    }
  }
  window.DetailX = window.DetailX || {};
  window.DetailX.money = money;

  /* ---------------------------------------------------------------------
     Header: fixed shell + scrolled state
     The header lives in a position:fixed wrapper (.site-header-fixed) so it
     never disappears while scrolling, regardless of section-wrapper height.
     On scroll, the announcement bar collapses and the header itself gets a
     solid/blurred background — see theme.css.
  --------------------------------------------------------------------- */
  var headerShell = document.querySelector(".site-header-fixed");
  var header = document.querySelector(".header");
  var announceBar = document.querySelector(".announce-bar");

  function onScrollHeader() {
    if (!headerShell) return;
    if (window.scrollY > 40) headerShell.classList.add("is-scrolled");
    else headerShell.classList.remove("is-scrolled");
  }
  document.addEventListener("scroll", onScrollHeader, { passive: true });
  onScrollHeader();

  function setHeaderOffsetVars() {
    if (!header) return;
    var headerHeight = header.offsetHeight;
    var announceHeight = announceBar ? announceBar.scrollHeight : 0;
    document.documentElement.style.setProperty("--header-offset", (headerHeight + announceHeight) + "px");
    document.documentElement.style.setProperty("--header-scroll-offset", (headerHeight + 16) + "px");
  }
  setHeaderOffsetVars();
  window.addEventListener("resize", setHeaderOffsetVars);
  window.addEventListener("load", setHeaderOffsetVars);

  /* ---------------------------------------------------------------------
     Mobile menu
  --------------------------------------------------------------------- */
  var menuToggle = document.getElementById("menuToggle");
  var mobileNav = document.getElementById("mobileNav");
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener("click", function () {
      var isOpen = mobileNav.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", String(isOpen));
      menuToggle.setAttribute("aria-label", isOpen ? "Fermer le menu" : "Ouvrir le menu");
    });
    mobileNav.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", function () {
        mobileNav.classList.remove("is-open");
        menuToggle.setAttribute("aria-expanded", "false");
        menuToggle.setAttribute("aria-label", "Ouvrir le menu");
      });
    });
  }

  /* ---------------------------------------------------------------------
     Scroll reveal
  --------------------------------------------------------------------- */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && !prefersReducedMotion && revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
    revealEls.forEach(function (el) {
      var delay = el.getAttribute("data-reveal-delay");
      if (delay) el.style.setProperty("--reveal-delay", delay + "ms");
      io.observe(el);
    });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------------------------------------------------------------------
     FAQ accordion (works for any .faq-item on the page)
  --------------------------------------------------------------------- */
  document.querySelectorAll(".faq-item").forEach(function (item) {
    var btn = item.querySelector(".faq-q");
    var panel = item.querySelector(".faq-a");
    if (!btn || !panel) return;
    btn.addEventListener("click", function () {
      var isOpen = btn.getAttribute("aria-expanded") === "true";
      var group = item.closest(".faq-list");
      if (group) {
        group.querySelectorAll(".faq-item").forEach(function (other) {
          if (other === item) return;
          other.querySelector(".faq-q").setAttribute("aria-expanded", "false");
          other.querySelector(".faq-a").style.maxHeight = null;
        });
      }
      if (!isOpen) {
        btn.setAttribute("aria-expanded", "true");
        panel.style.maxHeight = panel.scrollHeight + "px";
      } else {
        btn.setAttribute("aria-expanded", "false");
        panel.style.maxHeight = null;
      }
    });
  });

  /* ---------------------------------------------------------------------
     Before / after interactive sliders
  --------------------------------------------------------------------- */
  document.querySelectorAll("[data-ba-slider]").forEach(function (wrap) {
    var slider = wrap.querySelector(".ba-slider");
    var after = wrap.querySelector(".ba-after");
    if (!slider || !after) return;
    function update(value) {
      after.style.clipPath = "inset(0 " + (100 - value) + "% 0 0)";
      wrap.style.setProperty("--pos", value + "%");
    }
    slider.addEventListener("input", function () { update(Number(slider.value)); });
    update(Number(slider.value || 50));
  });

  /* ---------------------------------------------------------------------
     Product gallery thumbnails
  --------------------------------------------------------------------- */
  document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
    var main = gallery.querySelector(".gallery-main img");
    var thumbs = gallery.querySelectorAll(".thumb");
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        var alt = thumb.getAttribute("data-alt");
        if (main && full) {
          main.setAttribute("src", full);
          if (alt) main.setAttribute("alt", alt);
        }
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  });

  /* ---------------------------------------------------------------------
     Product variant picker (price / availability sync)
  --------------------------------------------------------------------- */
  document.querySelectorAll("[data-product-form]").forEach(function (formWrap) {
    var dataScript = formWrap.querySelector("[data-product-json]");
    if (!dataScript) return;
    var product;
    try { product = JSON.parse(dataScript.textContent); } catch (e) { return; }

    var select = formWrap.querySelector("[data-variant-select]");
    var idInput = formWrap.querySelector("[data-variant-id]");
    var priceNow = formWrap.querySelector("[data-price-now]");
    var priceOld = formWrap.querySelector("[data-price-old]");
    var stockBadge = formWrap.querySelector("[data-stock-badge]");
    var addBtn = formWrap.querySelector("[data-add-to-cart]");

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceNow) priceNow.textContent = money(variant.price);
      if (priceOld) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceOld.textContent = money(variant.compare_at_price);
          priceOld.hidden = false;
        } else {
          priceOld.hidden = true;
        }
      }
      if (stockBadge) {
        if (variant.available) {
          stockBadge.textContent = "En stock";
          stockBadge.classList.remove("out-of-stock");
          stockBadge.classList.add("in-stock");
        } else {
          stockBadge.textContent = "Rupture de stock";
          stockBadge.classList.remove("in-stock");
          stockBadge.classList.add("out-of-stock");
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.getAttribute("data-label-available") : addBtn.getAttribute("data-label-unavailable");
      }
    }

    if (select) {
      select.addEventListener("change", function () {
        var variant = product.variants.filter(function (v) { return String(v.id) === select.value; })[0];
        applyVariant(variant);
      });
    }
  });

  /* ---------------------------------------------------------------------
     Standalone quantity stepper (product forms) — plain +/- on an input,
     no network call; the surrounding <form> handles submission.
  --------------------------------------------------------------------- */
  document.querySelectorAll("[data-qty-standalone]").forEach(function (wrap) {
    var input = wrap.querySelector("input");
    var dec = wrap.querySelector("[data-qty-decrease]");
    var inc = wrap.querySelector("[data-qty-increase]");
    if (!input) return;
    if (dec) dec.addEventListener("click", function () {
      input.value = Math.max(1, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    if (inc) inc.addEventListener("click", function () {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });

  /* ---------------------------------------------------------------------
     Cart: AJAX add / render / update / remove
  --------------------------------------------------------------------- */
  var cartDrawer = document.getElementById("cartDrawer");
  var cartOverlay = document.getElementById("cartOverlay");
  var cartBody = document.getElementById("cartDrawerBody");
  var cartFooter = document.getElementById("cartDrawerFooter");
  var cartCountEls = document.querySelectorAll("[data-cart-count]");

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add("is-open");
    if (cartOverlay) cartOverlay.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    if (cartOverlay) cartOverlay.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  window.DetailX.openCart = openCart;
  window.DetailX.closeCart = closeCart;

  document.addEventListener("click", function (e) {
    var openTrigger = e.target.closest("[data-cart-open]");
    if (openTrigger) {
      e.preventDefault();
      openCart();
      refreshCart();
      return;
    }
    var closeTrigger = e.target.closest("[data-cart-close]");
    if (closeTrigger) {
      if (closeTrigger.tagName === "A" && closeTrigger.getAttribute("href") === "#") e.preventDefault();
      closeCart();
    }
  });
  if (cartOverlay) cartOverlay.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeCart();
  });

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function cartLineImageUrl(item) {
    var src = item.image || (item.featured_image && item.featured_image.url) || (item.product && item.product.featured_image) || null;
    if (!src) return null;
    return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=160";
  }

  function lineHtml(item) {
    var imgSrc = cartLineImageUrl(item);
    var img = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy" width="76" height="76">'
      : '<span class="cart-line-noimg" aria-hidden="true"><svg viewBox="0 0 32 32" width="28" height="28"><path d="M8 22 L16 8 L24 22 L19 22 L16 15.5 L13 22 Z" fill="currentColor"/></svg></span>';
    var variantLine = item.variant_title && item.variant_title !== "Default Title"
      ? '<div class="cart-line-variant">' + escapeHtml(item.variant_title) + "</div>"
      : "";
    return (
      '<div class="cart-line" data-line-key="' + item.key + '">' +
        '<div class="cart-line-image">' + img + "</div>" +
        '<div class="cart-line-info">' +
          '<div class="cart-line-title">' + escapeHtml(item.product_title) + "</div>" +
          variantLine +
          '<div class="cart-line-bottom">' +
            '<span class="cart-line-price">' + money(item.final_line_price) + "</span>" +
            '<span class="cart-line-qty">' +
              '<button type="button" data-qty-decrease aria-label="Diminuer la quantité">−</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" data-qty-input aria-label="Quantité">' +
              '<button type="button" data-qty-increase aria-label="Augmenter la quantité">+</button>' +
            "</span>" +
          "</div>" +
          '<button type="button" class="cart-line-remove" data-line-remove>Supprimer</button>' +
        "</div>" +
      "</div>"
    );
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    if (!cartBody) return;

    var upsellEl = document.getElementById("cartUpsell");

    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-empty">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 4h2l2.4 12.4a2 2 0 0 0 2 1.6h7.2a2 2 0 0 0 2-1.6L20 8H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="9" cy="20" r="1.4" fill="currentColor"/><circle cx="17" cy="20" r="1.4" fill="currentColor"/></svg>' +
          "<p>Votre panier est vide.</p>" +
          '<a href="/" class="btn btn-outline" data-cart-close>Continuer mes achats</a>' +
        "</div>";
      if (cartFooter) cartFooter.hidden = true;
      if (upsellEl) upsellEl.innerHTML = "";
      return;
    }

    if (cartFooter) cartFooter.hidden = false;
    cartBody.innerHTML = cart.items.map(lineHtml).join("");
    var subtotalEl = document.getElementById("cartSubtotal");
    if (subtotalEl) subtotalEl.textContent = money(cart.items_subtotal_price);

    bindLineEvents();
    renderUpsell(cart);
  }

  /* ---------------------------------------------------------------------
     Cart upsell — if the cart is missing one or two of the three DetailX
     products, suggest completing the Trio (the real discount is a Shopify
     automatic discount, applied at checkout). Missing exactly one product:
     suggest that single item. Missing two (only one product in cart):
     suggest adding both remaining items at once to complete the Trio.
  --------------------------------------------------------------------- */
  function renderUpsell(cart) {
    var container = document.getElementById("cartUpsell");
    if (!container) return;
    var products = window.DetailX && window.DetailX.products;
    if (!products || !products.kit || !products.renovateur || !products.serviette) {
      container.innerHTML = "";
      return;
    }

    var variantIds = cart.items.map(function (i) { return String(i.variant_id); });
    var trio = [
      { key: "kit", data: products.kit },
      { key: "renovateur", data: products.renovateur },
      { key: "serviette", data: products.serviette }
    ];
    var missing = trio.filter(function (p) {
      return variantIds.indexOf(String(p.data.variantId)) === -1 && p.data.available;
    }).map(function (p) { return p.data; });

    if (missing.length === 0 || missing.length === 3) {
      container.innerHTML = "";
      return;
    }

    var heading, note, items, addLabel;
    if (missing.length === 1) {
      var only = missing[0];
      heading = "Complétez votre Trio DetailX";
      note = "Ajoutez-le pour profiter de l’Offre Trio — la remise s’applique automatiquement au paiement.";
      items = [{ id: only.variantId, quantity: 1 }];
      addLabel = "Ajouter";
      var img1 = only.image ? '<img src="' + only.image + '" alt="" width="56" height="56" loading="lazy">' : "";
      container.innerHTML =
        '<div class="cart-upsell">' +
          '<p class="cart-upsell-heading">' + heading + "</p>" +
          '<div class="cart-upsell-item">' +
            '<div class="cart-upsell-media">' + img1 + "</div>" +
            '<div class="cart-upsell-info">' +
              '<span class="cart-upsell-title">' + escapeHtml(only.title) + "</span>" +
              '<span class="cart-upsell-price">' + money(only.price) + "</span>" +
            "</div>" +
            '<button type="button" class="btn btn-outline btn-sm" data-cart-add-items=\'' + JSON.stringify(items) + "'>" + addLabel + "</button>" +
          "</div>" +
          '<p class="cart-upsell-note">' + note + "</p>" +
        "</div>";
      return;
    }

    // missing.length === 2: only one product in cart, offer to complete the full Trio
    items = missing.map(function (p) { return { id: p.variantId, quantity: 1 }; });
    var names = missing.map(function (p) { return escapeHtml(p.title); }).join(" + ");
    container.innerHTML =
      '<div class="cart-upsell">' +
        '<p class="cart-upsell-heading">Complétez votre Trio DetailX</p>' +
        '<div class="cart-upsell-item">' +
          '<div class="cart-upsell-info">' +
            '<span class="cart-upsell-title">' + names + "</span>" +
          "</div>" +
          '<button type="button" class="btn btn-outline btn-sm" data-cart-add-items=\'' + JSON.stringify(items) + "'>Ajouter les deux</button>" +
        "</div>" +
        '<p class="cart-upsell-note">Ajoutez-les pour profiter de l’Offre Trio — la remise s’applique automatiquement au paiement.</p>' +
      "</div>";
  }

  function bindLineEvents() {
    cartBody.querySelectorAll("[data-line-key]").forEach(function (line) {
      var key = line.getAttribute("data-line-key");
      var input = line.querySelector("[data-qty-input]");
      var dec = line.querySelector("[data-qty-decrease]");
      var inc = line.querySelector("[data-qty-increase]");
      var remove = line.querySelector("[data-line-remove]");

      function changeQty(newQty) {
        line.style.opacity = "0.5";
        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: newQty }),
        })
          .then(function (r) { return r.json(); })
          .then(renderCart)
          .catch(function () { line.style.opacity = ""; });
      }

      if (dec) dec.addEventListener("click", function () { changeQty(Math.max(0, Number(input.value) - 1)); });
      if (inc) inc.addEventListener("click", function () { changeQty(Number(input.value) + 1); });
      if (input) input.addEventListener("change", function () { changeQty(Math.max(0, Number(input.value))); });
      if (remove) remove.addEventListener("click", function () { changeQty(0); });
    });
  }

  function refreshCart() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  window.DetailX.refreshCart = refreshCart;
  refreshCart();

  /* ---------------------------------------------------------------------
     Product forms: AJAX add to cart (supports "add single product" and
     "add duo bundle" forms alike via data-cart-add-items on the button)
  --------------------------------------------------------------------- */
  function setButtonLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.dataset.originalHtml = btn.innerHTML;
      btn.textContent = "Ajout en cours…";
      btn.disabled = true;
    } else {
      if (btn.dataset.originalHtml) btn.innerHTML = btn.dataset.originalHtml;
      btn.disabled = false;
    }
  }

  document.querySelectorAll("form[data-product-add-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-add-to-cart]");
      setButtonLoading(btn, true);
      var formData = new FormData(form);
      fetch("/cart/add.js", { method: "POST", body: formData })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (err) { throw err; });
          return r.json();
        })
        .then(function () {
          setButtonLoading(btn, false);
          refreshCart();
          openCart();
        })
        .catch(function () {
          setButtonLoading(btn, false);
          alert("Ce produit n'a pas pu être ajouté au panier. Merci de réessayer.");
        });
    });
  });

  /* Duo / bundle / upsell "add item(s)" buttons — event delegation so it also
     works for buttons injected later (cart upsell card, re-rendered cart).
     data-cart-add-items='[{"id":123,"quantity":1},{"id":456,"quantity":1}]' */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-cart-add-items]");
    if (!btn) return;
    e.preventDefault();
    var raw = btn.getAttribute("data-cart-add-items");
    var items;
    try { items = JSON.parse(raw); } catch (err) { return; }
    if (!items || !items.length || items.some(function (it) { return !it.id; })) {
      var target = document.querySelector(btn.getAttribute("data-fallback-target") || "");
      if (target) target.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth" });
      return;
    }
    setButtonLoading(btn, true);
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        setButtonLoading(btn, false);
        refreshCart();
        openCart();
      })
      .catch(function () {
        setButtonLoading(btn, false);
        alert("Cet article n'a pas pu être ajouté au panier. Merci de réessayer.");
      });
  });

  /* ---------------------------------------------------------------------
     Cart page (non-drawer) quantity controls
  --------------------------------------------------------------------- */
  document.querySelectorAll("[data-cart-page-qty]").forEach(function (wrap) {
    var key = wrap.getAttribute("data-line-key");
    var input = wrap.querySelector("input");
    var dec = wrap.querySelector("[data-qty-decrease]");
    var inc = wrap.querySelector("[data-qty-increase]");
    function apply(qty) {
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      }).then(function () { window.location.reload(); });
    }
    if (dec) dec.addEventListener("click", function () { apply(Math.max(0, Number(input.value) - 1)); });
    if (inc) inc.addEventListener("click", function () { apply(Number(input.value) + 1); });
    if (input) input.addEventListener("change", function () { apply(Math.max(0, Number(input.value))); });
  });

  /* ---------------------------------------------------------------------
     Mobile sticky CTA (product page) — show once hero/buybox scrolls away
  --------------------------------------------------------------------- */
  var stickyCta = document.getElementById("mobileStickyCta");
  var buybox = document.querySelector("[data-buybox]");
  if (stickyCta && buybox && "IntersectionObserver" in window) {
    var io2 = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
            stickyCta.classList.add("is-visible");
          } else {
            stickyCta.classList.remove("is-visible");
          }
        });
      },
      { threshold: 0 }
    );
    io2.observe(buybox);
  }
})();
